import { render, staticRenderFns } from "./ChartCard.vue?vue&type=template&id=50d93242&scoped=true"
import script from "./ChartCard.vue?vue&type=script&lang=js"
export * from "./ChartCard.vue?vue&type=script&lang=js"
import style1 from "./ChartCard.vue?vue&type=style&index=1&id=50d93242&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d93242",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50d93242')) {
      api.createRecord('50d93242', component.options)
    } else {
      api.reload('50d93242', component.options)
    }
    module.hot.accept("./ChartCard.vue?vue&type=template&id=50d93242&scoped=true", function () {
      api.rerender('50d93242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PriceWatcher/ChartCard.vue"
export default component.exports